<template>
	<div class="form-container">
		<h2 class="form-title">회원 탈퇴 이유</h2>

		<form @submit.prevent="onSubmitForm">
			<div class="form-group">
				<label class="form-label">어떤 점이 불편하셨나요?</label>
				<select v-model="userLeave" class="form-select">
					<option value="">선택하세요</option>
					<option value="배송불만">배송불만</option>
					<option value="상품의 다양성/가격 품질 불만">
						상품의 다양성/가격 품질 불만
					</option>
					<option value="교환/환불/반품 불만">교환/환불/반품 불만</option>
					<option value="실질적인 혜택부족">실질적인 혜택부족</option>
					<option value="사용이 불편함">사용이 불편함</option>
					<option value="개인정보 유출우려">개인정보 유출우려</option>
					<option value="자주 사용하지 않음">자주 사용하지 않음</option>
					<option value="기타사유">기타사유</option>
				</select>
			</div>

			<div class="form-group">
				<label class="form-label"
					>(유)하이모에 하고 싶으신 말을 남겨주세요.</label
				>
				<textarea
					v-model="userLeaveMemo"
					class="form-input"
					rows="10"
					placeholder="500자 이내로 입력하세요"
				></textarea>
			</div>

			<div class="form-group form-button">
				<Btn type="submit" color="primary" x-large block>회원 탈퇴</Btn>
			</div>
		</form>
	</div>
</template>

<script>
import mixin from '@/mixins/mixin';
import Btn from '@/components/common/Btn';

import { leaveUser } from '@/api';
import { sendToID } from '@/utils/interface';

export default {
	mixins: [mixin],
	components: {
		Btn,
	},
	data() {
		return {
			userLeave: '',
			userLeaveMemo: '',
		};
	},
	computed: {
		userId() {
			return this.$store.state.userStore.user.user_id;
		},
	},
	methods: {
		async onSubmitForm() {
			const params = {
				userId: this.userId,
				userLeave: this.userLeave,
				userLeaveMemo: this.userLeaveMemo,
			};

			const { data } = await leaveUser(params);

			const message = data.message;
			const options = {
				message,
			};
			const dialog = this.showAlert(options);

			// 탈퇴 완료 후 로그아웃 처리 및 로그인 페이지로 이동
			if (data.code === '00000') {
				// app으로 빈 아이디값 전달
				sendToID('');
				// 로그인 토큰 삭제 및 유저 스토어 초기화
				this.$store.dispatch('userStore/userLogout');

				dialog.then(() => {
					this.$router.push({ name: 'login' });
				});
			}
		},
	},
};
</script>
